import { CONTRACT_STATUS } from "@constants/Enums";
import { error_message } from "@constants/Errors";

export const validateUnitPrice = (
  errorToast: (msg: string) => void,
  setUnitPriceError: (value: boolean) => void,
  contractData: any[],
) => {
  const regex = /^[0-9]*$/;
  let valid = true;

  contractData.forEach((contract) => {
    if (contract.status === CONTRACT_STATUS.ACTIVE) {
      const str = contract.unit_price.toString();
      if (str === "0") {
        valid = false;
        errorToast(error_message.tenant.blank_unit_price);
      }
      if (!regex.test(str)) {
        valid = false;
        errorToast(error_message.tenant.bad_unit_price);
      }
    }
  });

  setUnitPriceError(valid);
  return valid;
};
